<template lang="pug">
div
  el-row
    el-row.marginTop
      el-col(:span="12")
        app-display(
          label="Tipo de cadastro:",
          :content="tipo",
        )
      el-col(:span="12")
        app-display(
          label="Data de cadastro:",
          :content="this.dataCadastro",
        )
  el-row
    app-divider(label="Qualificação")
    .margemTop
      app-display(
        label="Pertence ao Projeto Integrado Trairão?",
        :content="qualificacao.pertenceAoProjeto ? 'Sim, ' + qualificacao.gleba.nome : 'Não'",
        :class = "compararQualificacaoPermuta && compararQualificacaoPermuta.mudouPertenceAoProjeto ? 'text': '' "
      )
      app-display(
        label="O interessado é o beneficiário original?",
        :content="qualificacao.beneficiarioOriginal ? 'Sim' : 'Não'",
        :class = "compararQualificacaoPermuta && compararQualificacaoPermuta.mudouBeneficiarioOriginal ? 'text': '' "
      )
      app-display(
        label="O Valor da Terra Nua (VTN) foi pago integralmente?",
        :content="qualificacao.beneficiarioOriginal ? 'Sim' : 'Não'",
        :class = "compararQualificacaoPermuta && compararQualificacaoPermuta.mudouBeneficiarioOriginal ? 'text': '' "
      )
</template>
<script>
import AppDisplay from '@/components/AppDisplay'
import AppDivider from '@/components/AppDivider'

export default {
  components: {
    AppDisplay,
    AppDivider
  },
  props: {
    qualificacao: {
      type: Object,
      required: true
    },
    tipo: {
      type: String,
      required: true
    },
    dataCadastro: {
      type: String,
      required: true
    },
    compararQualificacaoPermuta: {
      type: Object,
      required: false
    }
  },

  computed: {
    tipoInformacaoDesejada () {
      if (this.informacaoDesejada && this.informacaoDesejada.descricaoOutro) {
        return 'Outros - ' + this.informacaoDesejada.descricaoOutro
      }
      if (this.informacaoDesejada && this.informacaoDesejada.tipoInformacao != null && this.informacaoDesejada.tipoInformacao.descricao === 'Outro') {
        return this.informacaoDesejada.outro
      }
      if (this.informacaoDesejada && this.informacaoDesejada.tipoInformacao != null && this.informacaoDesejada.tipoInformacao.descricao) {
        return this.informacaoDesejada.tipoInformacao.descricao
      }
      return '-'
    },
    getJustificativa () {
      return this.informacaoDesejada && this.informacaoDesejada.justificativa !== null ? this.informacaoDesejada.justificativa : '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.margem {
  margin-left: 6px;
}
.margemTop {
  margin-top: 15px;
}
>>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/informacoesPermuta/InformacoesQualificacaoPermuta.vue